import RuleList from './RuleList';
import RuleEdit from './RuleEdit';
import RuleCreate from './RuleCreate';
import icon from '../../icon/IcnOperateSetting';

export default {
    list: RuleList,
    edit: RuleEdit,
    //show: RuleEdit,
    create: RuleCreate,
    icon: icon,
}